<div class="hidden-md hidden-lg">
  <app-nav></app-nav>
</div>
<div class="visible-lg visible-md">
  <app-headermain></app-headermain>
</div>

<!-- Hidden reload trigger -->
<button id="openReloadButton" [class.is-hidden]="isHidden" data-toggle="modal" data-target="#myModalReload" style="display:none;"></button>

<div class="cfm-page-bg">

  <!-- Branding -->
  <div style="margin-bottom: 28px; text-align: center;">
    <img src="assets/img/logo-white.png" alt="BuuPass" style="height: 36px;" onerror="this.style.display='none'">
  </div>

  <!-- Main card -->
  <div class="cfm-main-card cfm-card">

    <!-- Route header (green) -->
    <div class="cfm-route-header">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center; gap: 14px;">
          <div style="width: 46px; height: 46px; background: rgba(255,255,255,0.15); border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <img [src]="carrierLogoService.getCarrierLogo(confirmData?.booking_data?.slices?.[0]?.segments?.[0]?.marketing_carrier)"
              style="width: 36px; height: 36px; object-fit: contain;"
              (error)="carrierLogoService.setLogoPlaceholder($event)">
            </div>
            <div>
              <div class="cfm-route-iata">
                {{ confirmData?.booking_data?.slices?.[0]?.origin?.iata_code }}
                <span class="cfm-route-arrow">→</span>
                {{ confirmData?.booking_data?.slices?.[0]?.destination?.iata_code }}
              </div>
              <div class="cfm-airline-name">
                {{ confirmData?.booking_data?.slices?.[0]?.segments?.[0]?.marketing_carrier?.name }}
              </div>
            </div>
          </div>
          <div style="text-align: right;">
            <div style="font-size: 11px; opacity: 0.7; text-transform: uppercase; letter-spacing: 1px;">Total</div>
            @if (!confirmData?.promo_discount) {
              <div style="font-size: 20px; font-weight: 800;">
                {{ confirmData?.booking_data?.total_currency }} {{ confirmData?.booking_data?.total_amount | number:'1.0-0' }}
              </div>
            }
            @if (confirmData?.promo_discount) {
              <div>
                <div style="font-size: 13px; opacity: 0.65; text-decoration: line-through;">
                  {{ confirmData?.booking_data?.total_currency }} {{ confirmData?.booking_data?.total_amount | number:'1.0-0' }}
                </div>
                <div style="font-size: 20px; font-weight: 800; color: #ffe566;">
                  {{ confirmData?.booking_data?.total_currency }} {{ (confirmData.booking_data.total_amount - confirmData.promo_discount.user.amount) | number:'1.0-0' }}
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Booking details -->
      <div class="cfm-body">
        <div class="cfm-info-row">
          <span class="cfm-info-label"><i class="fa fa-tag" style="margin-right: 6px; color:#1a7a3c;"></i>Booking Reference</span>
          <span class="cfm-info-value" style="font-family: monospace; font-size: 15px; color: #1a7a3c; letter-spacing: 1px;">
            {{ confirmData?.payee?.booking_reference || confirmData?.data?.internal_booking_reference }}
          </span>
        </div>
        <div class="cfm-info-row">
          <span class="cfm-info-label"><i class="fa fa-calendar" style="margin-right: 6px;"></i>Departure</span>
          <span class="cfm-info-value">{{ confirmData?.booking_data?.slices?.[0]?.departing_day?.split('T')[0] }}</span>
        </div>
        <div class="cfm-info-row">
          <span class="cfm-info-label"><i class="fa fa-users" style="margin-right: 6px;"></i>Passengers</span>
          <span class="cfm-info-value">{{ confirmData?.booking_data?.passengers?.length }} Passenger(s)</span>
        </div>
        <div class="cfm-info-row">
          <span class="cfm-info-label"><i class="fa fa-user" style="margin-right: 6px;"></i>Lead Passenger</span>
          <span class="cfm-info-value">
            {{ confirmData?.payee?.customer?.first_name }} {{ confirmData?.payee?.customer?.last_name }}
          </span>
        </div>
        <div class="cfm-info-row">
          <span class="cfm-info-label">
            <i [class]="(confirmData?.payee?.payments === 'mpesa' || confirmData?.payee?.payments === 'airtel') ? 'fa fa-mobile-alt' : 'fa fa-credit-card'" style="margin-right: 6px;"></i>
            Payment Method
          </span>
          <span class="cfm-info-value" style="text-transform: capitalize;">{{ confirmData?.payee?.payments }}</span>
        </div>
      </div>

      <!-- Payment processing status -->
      <div class="cfm-status-section">
        <div class="cfm-spinner-wrap">
          <!-- Ripple rings -->
          <!-- Spinner -->
          <svg class="cfm-spinner" style="width: 76px; height: 76px; position: absolute; top: 0; left: 0;" viewBox="0 0 76 76" fill="none">
            <circle cx="38" cy="38" r="32" stroke="#fce8f0" stroke-width="6"/>
            <path d="M38 6 A32 32 0 0 1 70 38" stroke="#CF2264" stroke-width="6" stroke-linecap="round"/>
          </svg>
          <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); width: 38px; height: 38px; background: #fce8f0; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <i class="fa fa-lock" style="color: #CF2264; font-size: 15px;"></i>
          </div>
        </div>

        <h3 style="font-size: 18px; font-weight: 700; color: #111; margin: 0 0 8px;">Awaiting Payment Confirmation</h3>

        @if (isSaving) {
          <p style="color: #555; font-size: 14px; line-height: 1.7; margin: 0;">
            Saving your reservation...
          </p>
        }
        @if (isWaiting && !isSaving) {
          <p style="color: #555; font-size: 14px; line-height: 1.7; margin: 0;">
            Processing your payment, please wait...
          </p>
        }
        @if (isError && !isWaiting) {
          <p style="color: #c0392b; font-size: 14px; line-height: 1.7; margin: 0;">
            {{ errorMessage }}
          </p>
        }

        <!-- Bouncing dots -->
        <div class="cfm-dots-wrap">
          <span class="cfm-dot"></span>
          <span class="cfm-dot"></span>
          <span class="cfm-dot"></span>
        </div>

        <!-- M-Pesa hint -->
        @if (confirmData?.payee?.payments === 'mpesa') {
          <div class="cfm-mpesa-hint">
            <i class="fa fa-info-circle" style="color: #e07800; font-size: 17px; flex-shrink: 0; margin-top: 1px;"></i>
            <span>Check your phone for an M-Pesa prompt and enter your PIN to complete the payment. This page will update automatically once confirmed.</span>
          </div>
        }

        @if (confirmData?.payee?.payments === 'airtel') {
          <div class="cfm-mpesa-hint">
            <i class="fa fa-info-circle" style="color: #e07800; font-size: 17px; flex-shrink: 0; margin-top: 1px;"></i>
            <span>Check your phone for the Airtel Money payment prompt and complete the payment. This page will update automatically once confirmed.</span>
          </div>
        }

        <p class="cfm-no-refresh">
          <i class="fa fa-shield-alt" style="margin-right: 4px; color: #aaa;"></i>
          Secure connection — do not close or refresh this page
        </p>
      </div>

    </div>

    <!-- Footer note -->
    <p style="color: rgba(255,255,255,0.4); font-size: 12px; margin-top: 20px; text-align: center;">
      &copy; {{ 2025 }} BuuPass. All rights reserved.
    </p>

  </div>

  <!-- Reload error modal -->
  <div id="myModalReload" class="modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 420px;">
      <div class="modal-content" style="border-radius: 14px; border: none; box-shadow: 0 16px 48px rgba(0,0,0,0.2); overflow: hidden;">
        <div style="background: linear-gradient(135deg, #c0392b, #e74c3c); padding: 22px 24px 16px; color: white; text-align: center;">
          <div style="width: 52px; height: 52px; background: rgba(255,255,255,0.15); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px;">
            <i class="fa fa-exclamation-circle" style="font-size: 22px;"></i>
          </div>
          <h4 style="margin: 0; font-weight: 700; font-size: 17px;">Payment Confirmation Delayed</h4>
        </div>
        <div style="padding: 22px 24px 10px; text-align: center;">
          <button id="closeConfirmDialog" type="button" class="close" data-dismiss="modal" style="position: absolute; top: 12px; right: 16px; font-size: 20px; opacity: 0.6;">&times;</button>
          <p style="color: #555; font-size: 14px; line-height: 1.7; margin: 0;">
            We're having trouble confirming your payment. Please try reloading the page or contact support if the issue persists.
          </p>
        </div>
        <div style="padding: 12px 24px 24px; display: flex; gap: 12px;">
          <button (click)="backToHome()" class="btn" style="flex: 1; background: #f0f0f0; color: #555; border: none; border-radius: 8px; padding: 11px 0; font-weight: 600;">
            Cancel
          </button>
          <button (click)="retryConfirmation()" class="btn" style="flex: 1.5; background: #CF2264; color: white; border: none; border-radius: 8px; padding: 11px 0; font-weight: 700; box-shadow: 0 4px 12px rgba(207,34,100,0.3);">
            <i class="fa fa-redo" style="margin-right: 6px;"></i> Reload
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
